import { useState } from "react"
import { Button } from "@holigral/shared/ui/components/ui/button"
import { invariant } from "@holigral/shared/utils"
import { ChangeEmail, useMe, useResendVerifyEmail } from "@/profile"
import { useLogout } from "@/auth"
import { useT } from "@/i18n"

/**
 * Replaces the whole authenticated shell once the verification grace period
 * has expired, so there is no route left to escape to. The change-email form
 * is why /api/email is carved out of the backend block: a typo at signup is
 * the one way a genuine user ends up stuck behind this.
 */
export default function VerificationRequired() {
  const { t } = useT("auth")
  const { data: me } = useMe()
  const [correcting, setCorrecting] = useState(false)
  const resendEmail = useResendVerifyEmail()
  const logout = useLogout()

  invariant(me?.email)

  const handleCorrect = () => {
    setCorrecting(true)
  }

  return (
    <div className="mx-auto flex h-dvh max-w-md flex-col justify-center gap-4 p-6">
      <h1 className="text-2xl font-normal">{t("verificationRequiredTitle")}</h1>
      <p>{t("verificationRequiredBody", { email: me.email })}</p>

      {correcting ? (
        <ChangeEmail />
      ) : (
        <div className="flex flex-row gap-2">
          <Button variant="primary" onClick={resendEmail}>
            {t("common:resendVerifyEmail")}
          </Button>
          <Button variant="ghost" onClick={handleCorrect}>
            {t("verificationWrongAddress")}
          </Button>
        </div>
      )}

      <Button variant="ghost" onClick={logout}>
        {t("common:nav.logout")}
      </Button>
    </div>
  )
}
